<template>
    <div>
        <van-tabs color="#1989fa" v-model="active">

            <van-form @submit="onSubmit">
                <van-field
                        v-model="uservo.phone"
                        rows="3"
                        autosize
                        label="模拟手机号:"
                        type="textarea"
                        placeholder="请输入模拟登录的手机号"
                />
                <div style="margin: 16px">
                    <van-button round block type="info" native-type="submit"
                    >登录
                    </van-button
                    >
                </div>
            </van-form>
        </van-tabs>
    </div>
</template>
<script>
    import URL from "@/api/api";
    import {Toast} from "vant";
    import {setSession, setLocal } from '@/utils/utils'
    export default {

        data() {
            return {
                fieldValue: '',
                show: false,
                cascaderValue: '',
                isDisabled: false,
                active: "",
                question: "",
                pid: 0,
                cid: '',
                content: '',
                options: [],
                fieldNames: {
                    text: 'name',
                    value: 'code',
                    children: 'child',
                },
                uservo: {
                    phone: "",
                    openid: "",
                    selfPhoneNo: "",
                },

                message: "",
                productList: [],
                fileList: [],
                returnFileList: [],
                orderNo: this.$route.query.orderNo,
                status: "0",
                nickName: ""
            };
        },
        mounted() {
        },
        methods: {
            onSubmit(values) {
                this.uservo.openid = localStorage.getItem("openid");
                this.uservo.selfPhoneNo = localStorage.getItem("phone");
                this.$fetchPost(URL.getByPhoneNo.url, this.uservo).then(res => {
                    if (res.data.code === 20000) {
                        console.log("======>刷新缓存数据");
                        console.log(res.data.data);
                        setLocal("openid", res.data.data.openid);
                        setLocal("nickname", res.data.data.nickName);
                        setLocal("headimgurl", res.data.data.avatarName);
                        setLocal("userid", res.data.data.id);
                        setLocal("unionid", res.data.data.unionid);
                        setSession("openId", res.data.data.openid);
                        setSession("nickname", res.data.data.nickName);
                        setSession("headImgUrl", res.data.data.avatarName);
                        setSession("unionid", res.data.data.unionid);
                        setSession("userid", res.data.data.id);
                        setLocal("wechatnumber", res.data.data.openid);
                        setSession("nickname", res.data.data.nickName);
                        setSession("headImgUrl", res.data.data.avatarName);
                        this.$router.push('/')
                    } else {
                        Toast(res.data.msg);
                    }
                });
            },
        },
    };
</script>
<style scoped>
    .van-tab__pane {
        width: 95%;
        margin: 10px auto;
    }

    .van-card__title {
        max-height: 32px;
        font-weight: 600;
        line-height: 40px;
        font-size: 16px;
    }

    .dropdown-sty {
        width: 100%;
        display: flex;
        background: #fff;
    }

    .pro-tit {
        line-height: 50px;
        padding-left: 10px;
        font-size: 16px;
    }

    .van-dropdown-menu {
        /* width: 70%; */
    }

    .pro-sty >>> .van-dropdown-menu__bar {
        align-items: start;
        background-color: transparent;
        box-shadow: none;
    }

    .van-dropdown-menu__bar {
    }
</style>
